import * as toolbox from '../components/common/toolbox';
import * as types from './action-types';
import firebase from 'firebase/compat/app';
import { doc, updateDoc, deleteField, getDoc, setDoc, onSnapshot } from "firebase/firestore";

const firestore = firebase.firestore();
const _ = require('lodash');

export function subAssets(handle) {

    return async dispatch => {

        dispatch({ type: types.ASSETS + '_PENDING' });

        var query = firestore.collection(handle + '/assets/assets').where('deleted', '==', false);

        const unsubscribe = onSnapshot(query, (querySnapshot) => {
            var assets = [];
            querySnapshot.forEach((doc) => { assets.push({ ...doc.data(), id: doc.id }); });
            dispatch({ type: types.ASSETS + '_FULFILLED', data: assets, unsubscribe });
        });

    };
}

export function saveAsset(handle, assetForm, assetId, callback) {

    return async dispatch => {

        dispatch({ type: types.ASSETS + '_SAVE_PENDING' });

        var batch = firestore.batch();

        if (parseInt(assetId) < 1) {
            assetId = await nextAssetId(handle, batch);
        }
        const assetsRef = firestore.collection(handle + '/assets/assets');
        batch.set(assetsRef.doc(assetId), { ...assetForm }, { merge: true });
        batch.commit().then(() => {
            window.toastr.success('The Asset record has been successfully saved/updated', 'Asset Saved!');
            dispatch({ type: types.ASSETS + '_SAVE_FULFILLED' });
            if (typeof callback === 'function') callback(assetId);
        }).catch((error) => {
            toolbox.process_error(error, 'Asset NOT Saved!');
        });
    };
}
export function saveStockPartToAsset(handle, assetId, stockPartId, remove, callback) {

    return async dispatch => {

        dispatch({ type: types.ASSETS + '_SAVE_PENDING' });

        var batch = firestore.batch();

        const assetsRef = firestore.collection(handle + '/assets/assets').doc(assetId);
        batch.set(assetsRef, { parts: (remove) ? firebase.firestore.FieldValue.arrayRemove(stockPartId) : firebase.firestore.FieldValue.arrayUnion(stockPartId) }, { merge: true });

        const stockPartRef = firestore.collection(handle + '/stock-parts/stock-parts').doc(stockPartId);
        batch.set(stockPartRef, { associatedAssets: (remove) ? firebase.firestore.FieldValue.arrayRemove(assetId) : firebase.firestore.FieldValue.arrayUnion(assetId) }, { merge: true });
        batch.commit().then(() => {
            if (!remove) window.toastr.success(`The Stock Part has been successfully added`);
            if (remove) window.toastr.warning(`The Stock Part has been successfully removed`);
            dispatch({ type: types.ASSETS + '_SAVE_FULFILLED' });
            if (typeof callback === 'function') callback(assetId);
        }).catch((error) => {
            toolbox.process_error(error, 'Stock Part NOT linked!');
        });
    };
}

export function selectAssetType(type) {
    return async dispatch => {
        dispatch({ type: types.ASSET_TYPE + '_SELECTED', data: type });
    };
}

export function saveAssetStockParts(handle, parts, id) {
    return async dispatch => {

        dispatch({ type: types.ASSETS + '_SAVE_PENDING' });
        var query = firestore.collection(handle + '/assets/assets').doc(id);
        await updateDoc(query, {
            ['parts']: [...parts]
        }).then(() => {
            window.toastr.success('The record has been successfully saved/updated', 'Stock Part Saved!');
            dispatch({ type: types.ASSETS + '_SAVE_FULFILLED' });
        }).catch((error) => {
            toolbox.process_error(error, 'Asset NOT Saved!');
        });
    };
}

async function nextAssetId(handle, batch) {
    const table = 'assets';
    const field = 'nextAssetId';
    const startingId = 1000;

    return toolbox.nextId(handle, batch, table, field, startingId);
}